import axios from 'axios';
import { Task } from '../model/task.model';
const apiUrl = process.env.REACT_APP_BRAVERMAN
export const getAllTaskFromServer = async () => {
    let res = await axios.get(`${apiUrl}Tasks`);
    if (res) {
        let tasks = res.data;  // שומרים את הנתונים במשתנה

        // ממיינים מהחדש לישן לפי creationDate
        tasks.sort((a, b) => new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime());

        console.log("Tasks sorted from newest to oldest:", tasks);

        return tasks;  // מחזירים את הרשימה הממוינת
    }
};
export const getTaskById = async (taskId: string) => {
    try {
        let response = await axios.get(`${apiUrl}Tasks/GetById/${taskId}`);
        return response.data;
    }
    catch (error) {
        console.error('Error fetching task :', error);
        return error;
    }
}
export const getTasksByUserId = async (userId: string) => {
    try {
        let response = await axios.get(`${apiUrl}Tasks/GetByUserId/${userId}`);
        return response.data;
    }
    catch (error) {
        console.error('Error fetching task :', error);
        return error;
    }
}
export const UpDateTask = async (t: Task) => {
    try {
        const res = await axios.put(`${apiUrl}Tasks/Update`, t);
        return res.data;
    } catch (error) {
        console.error("Error updating task:", error);
        throw error;
    }
};

export const addTask = async (newTask: Task) => {
    debugger
    let res = await axios.post(`${apiUrl}Tasks/Add`,
        newTask
    )
    if (res) {
        console.log(res);
        return await res.data;
    }
}
export const getTaskStatusChanges = async (taskId: string) => {
    try {
        let res = await axios.get(`${apiUrl}Tasks/GetTaskStatusChanges/${taskId}`)
        return res.data;
    }
    catch (error) {
        console.error('Error fetching logs of this task', error);
        return null;
    }
}
export const deleteTask = async (taskId: string) => {
    try {
        const res = await axios.delete(`${apiUrl}Tasks/Delete/${taskId}`);
        return res.data;
    } catch (error) {

        console.error("Error deleting task:", error);
        throw error;
    }
};
